import { createAsyncActionType } from '@qadra/frontend-common/redux';

export const LOGIN = createAsyncActionType('qadraSSO', 'LOGIN');
export const FORGOT = createAsyncActionType('qadraSSO', 'FORGOT');
export const PASSWORD_RESET = createAsyncActionType('qadraSSO', 'PASSWORD_RESET');
export const ACTIVATE = createAsyncActionType('qadraSSO', 'ACTIVATE');
export const CONFIRM_EMAIL = createAsyncActionType('qadraSSO', 'CONFIRM_EMAIL');
